package blazern.lexisoup.utils

actual fun getKotlinPlatform() = KotlinPlatform.JS
